var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrundrissOben(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "100%",
    viewBox: "0 0 1970 2580",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    id: "grundriss-oben",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "9e 2nd floor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Other furniture"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Meeting rooms"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wood room"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Main room"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.847 2299.87H728.044V2393.51H378.847V2299.87Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Table_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chairs_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.493 2431.29C380.493 2444.89 393.203 2455.93 406.848 2455.93C420.493 2455.93 433.202 2444.89 433.202 2431.29L431.555 2406.65H382.141L380.493 2431.29ZM676.982 2431.29C676.982 2444.89 689.691 2455.93 703.336 2455.93C716.981 2455.93 729.691 2444.89 729.691 2431.29L728.044 2406.65H678.629L676.982 2431.29ZM617.684 2431.29C617.684 2444.89 630.394 2455.93 644.039 2455.93C657.684 2455.93 670.393 2444.89 670.393 2431.29L668.746 2406.65H619.331L617.684 2431.29ZM558.386 2431.29C558.386 2444.89 571.096 2455.93 584.741 2455.93C598.386 2455.93 611.095 2444.89 611.095 2431.29L609.448 2406.65H560.034L558.386 2431.29ZM499.089 2431.29C499.089 2444.89 511.798 2455.93 525.443 2455.93C539.088 2455.93 551.798 2444.89 551.798 2431.29L550.151 2406.65H500.736L499.089 2431.29ZM439.791 2431.29C439.791 2444.89 452.501 2455.93 466.146 2455.93C479.791 2455.93 492.5 2444.89 492.5 2431.29L490.853 2406.65H441.438L439.791 2431.29Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.848 2237.45C393.203 2237.45 380.494 2248.48 380.494 2262.09L382.141 2286.73H431.555L433.203 2262.09C433.203 2248.48 420.493 2237.45 406.848 2237.45Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.336 2237.45C689.691 2237.45 676.982 2248.48 676.982 2262.09L678.629 2286.73H728.044L729.691 2262.09C729.691 2248.48 716.981 2237.45 703.336 2237.45Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.039 2237.45C630.394 2237.45 617.684 2248.48 617.684 2262.09L619.331 2286.73H668.746L670.393 2262.09C670.393 2248.48 657.684 2237.45 644.039 2237.45Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.741 2237.45C571.096 2237.45 558.387 2248.48 558.387 2262.09L560.034 2286.73H609.448L611.096 2262.09C611.096 2248.48 598.386 2237.45 584.741 2237.45Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.443 2237.45C511.798 2237.45 499.089 2248.48 499.089 2262.09L500.736 2286.73H550.151L551.798 2262.09C551.798 2248.48 539.088 2237.45 525.443 2237.45Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.146 2237.45C452.501 2237.45 439.791 2248.48 439.791 2262.09L441.438 2286.73H490.853L492.5 2262.09C492.5 2248.48 479.791 2237.45 466.146 2237.45Z",
    fill: "white",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Corner room"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1724.57 2477.29C1796.44 2477.29 1854.7 2419.18 1854.7 2347.51C1854.7 2275.84 1796.44 2217.73 1724.57 2217.73C1652.71 2217.73 1594.45 2275.84 1594.45 2347.51C1594.45 2419.18 1652.71 2477.29 1724.57 2477.29Z",
    fill: "#626060",
    fillOpacity: 0.1,
    id: "Carpet"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725.25 2408.16C1759.36 2408.16 1787.02 2380.58 1787.02 2346.56C1787.02 2312.54 1759.36 2284.95 1725.25 2284.95C1691.14 2284.95 1663.48 2312.54 1663.48 2346.56C1663.48 2380.58 1691.14 2408.16 1725.25 2408.16Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Round table"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.27 2366.43C1612.88 2366.43 1603.69 2355.77 1603.69 2344.26C1603.69 2332.76 1612.88 2322.08 1624.27 2322.08L1644.86 2323.48V2365.05L1624.27 2366.43ZM1819.57 2365.99C1830.96 2365.99 1840.15 2355.31 1840.15 2343.81C1840.15 2332.3 1830.96 2321.64 1819.57 2321.64L1798.98 2323.02V2364.59L1819.57 2365.99ZM1751.29 2248.5C1756.99 2238.66 1770.86 2236.05 1780.84 2241.8C1790.84 2247.55 1795.5 2260.84 1789.8 2270.68L1778.3 2287.76L1742.2 2266.98L1751.29 2248.5ZM1654.04 2417.39C1648.34 2427.23 1653 2440.52 1663 2446.27C1672.98 2452.02 1686.85 2449.41 1692.55 2439.57L1701.64 2421.11L1665.54 2400.31L1654.04 2417.39ZM1654.22 2274.13C1648.52 2264.29 1653.19 2251.01 1663.18 2245.26C1673.17 2239.51 1687.03 2242.11 1692.73 2251.95L1701.83 2270.43L1665.72 2291.23L1654.22 2274.13ZM1752.25 2442.58C1757.94 2452.42 1771.81 2455.03 1781.81 2449.28C1791.79 2443.53 1796.47 2430.26 1790.77 2420.42L1779.28 2403.31L1743.15 2424.11L1752.25 2442.59V2442.58Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Chairs_3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Upper meeting room"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1330.9 295.698C1366.38 295.698 1395.14 250.098 1395.14 193.846C1395.14 137.595 1366.38 91.9948 1330.9 91.9948C1295.42 91.9948 1266.66 137.595 1266.66 193.846C1266.66 250.098 1295.42 295.698 1330.9 295.698Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Table_3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.07 220.13C1218.43 220.13 1207.37 207.455 1207.37 193.846C1207.37 180.238 1218.43 167.562 1232.07 167.562L1256.78 169.205V218.488L1232.07 220.13ZM1433.03 167.562C1446.67 167.562 1457.73 180.238 1457.73 193.846C1457.73 207.455 1446.67 220.13 1433.03 220.13L1408.32 218.488V169.205L1433.03 167.562ZM1405.89 91.9357C1418.72 87.2817 1433.46 95.4183 1438.13 108.207C1442.79 120.996 1436.74 136.68 1423.92 141.335L1400.14 148.218L1383.24 101.909L1405.89 91.9373V91.9357ZM1423.92 244.713C1436.74 249.367 1442.79 265.05 1438.12 277.839C1433.46 290.628 1418.72 298.766 1405.89 294.111L1383.24 284.139L1400.14 237.83L1423.92 244.713ZM1238.82 141.606C1226 136.952 1219.95 121.269 1224.62 108.48C1229.28 95.691 1244.02 87.5544 1256.85 92.2084L1279.5 102.18L1262.6 148.489L1238.82 141.606ZM1257.56 294.114C1244.73 298.768 1229.99 290.631 1225.33 277.842C1220.66 265.055 1226.71 249.37 1239.53 244.716L1263.31 237.833L1280.21 284.142L1257.56 294.114Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Chairs_4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Kitchen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kitchen unit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M800.519 1568.84H826.873V1596.77H800.519V1568.84ZM831.815 1568.84H858.169V1596.77H831.815V1568.84ZM800.519 1601.7H826.873V1629.62H800.519V1601.7ZM831.815 1601.7H858.169V1629.62H831.815V1601.7Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.401 1959.82V1787.33H793.929V1393.06H866.404V1994.32H657.215V1844.82H706.63V1959.82H810.401Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chairs_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595.218 1817.82C603.857 1817.82 610.86 1810.53 610.86 1801.54C610.86 1792.55 603.857 1785.25 595.218 1785.25C586.578 1785.25 579.576 1792.55 579.576 1801.54C579.576 1810.53 586.578 1817.82 595.218 1817.82Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.55 1774.32C682.19 1774.32 689.193 1767.03 689.193 1758.04C689.193 1749.05 682.19 1741.75 673.55 1741.75C664.911 1741.75 657.908 1749.05 657.908 1758.04C657.908 1767.03 664.911 1774.32 673.55 1774.32Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.55 1721.59C682.19 1721.59 689.193 1714.3 689.193 1705.31C689.193 1696.32 682.19 1689.02 673.55 1689.02C664.911 1689.02 657.908 1696.32 657.908 1705.31C657.908 1714.3 664.911 1721.59 673.55 1721.59Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.514 1774.32C528.154 1774.32 535.156 1767.03 535.156 1758.04C535.156 1749.05 528.154 1741.75 519.514 1741.75C510.875 1741.75 503.872 1749.05 503.872 1758.04C503.872 1767.03 510.875 1774.32 519.514 1774.32Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.514 1721.59C528.154 1721.59 535.156 1714.3 535.156 1705.31C535.156 1696.32 528.154 1689.02 519.514 1689.02C510.875 1689.02 503.872 1696.32 503.872 1705.31C503.872 1714.3 510.875 1721.59 519.514 1721.59Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.218 1494.88C603.857 1494.88 610.86 1487.58 610.86 1478.59C610.86 1469.6 603.857 1462.31 595.218 1462.31C586.578 1462.31 579.576 1469.6 579.576 1478.59C579.576 1487.58 586.578 1494.88 595.218 1494.88Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M688.511 1514.63H653.921V1664.12H688.511V1514.63Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Bench"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.555 1515.38H505.965V1664.88H540.555V1515.38Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Bench_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.739 1511.34H640.744V1770.9H556.739V1511.34Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Kitchen table"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.887 1738.46L303.887 1558.46L191.279 1558.46L191.279 1738.46L303.887 1738.46Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Coffee table"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Chairs_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.696 1692.12C388.543 1692.12 402.198 1678.58 402.198 1661.88C402.198 1645.19 388.543 1631.64 371.696 1631.64C354.849 1631.64 341.193 1645.19 341.193 1661.88C341.193 1678.58 354.849 1692.12 371.696 1692.12Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.173 1844.11C254.02 1844.11 267.675 1830.56 267.675 1813.87C267.675 1797.18 254.02 1783.63 237.173 1783.63C220.326 1783.63 206.671 1797.18 206.671 1813.87C206.671 1830.56 220.326 1844.11 237.173 1844.11Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.489 1814.65C371.336 1814.65 384.991 1801.1 384.991 1784.4C384.991 1767.71 371.336 1754.16 354.489 1754.16C337.642 1754.16 323.987 1767.71 323.987 1784.4C323.987 1801.1 337.642 1814.65 354.489 1814.65Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Couch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.1742 1717.13H161.699V1746.71H55.9643V1424.28H379.21V1527.81H349V1453.86H86.1742V1717.13Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.473 1424.53V1530.22H161.992V1750.77H55.5326L55.533 1424.53H379.473Z",
    fill: "white",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Phone box room"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cabinets"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.323 2476.92H202.077V2550.77H265.323V2476.92Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.323 2393.85H202.077V2467.69H265.323V2393.85Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3306 2455.38H23.1385V2553.85H66.3306V2455.38Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.323 2144.62H202.077V2273.85H265.323V2144.62Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3306 2144.62H23.1385V2243.08H66.3306V2144.62Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Phone boxes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1384 2353.85H112.608V2452.76H23.1384V2353.85Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.608 2246.15H23.1384V2345.07H112.608V2246.15Z",
    fill: "white",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Chill area"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Couch_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1311.02 2525.71V2463.08L1345.13 2463.08V2550.77L973.365 2550.77L973.365 2463.08L1007.47 2463.08L1007.47 2525.71L1311.02 2525.71Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.28 2455.38L970.28 2550.77L1346.67 2550.77V2455.38L970.28 2455.38Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1166.32 2402.44C1187.48 2402.44 1204.64 2384.03 1204.64 2361.34C1204.64 2338.65 1187.48 2320.24 1166.32 2320.24C1145.15 2320.24 1127.99 2338.65 1127.99 2361.34C1127.99 2384.03 1145.15 2402.44 1166.32 2402.44Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Coffee table_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.75 2279.92C1120.59 2279.92 1134.25 2266.37 1134.25 2249.67C1134.25 2232.98 1120.59 2219.43 1103.75 2219.43C1086.9 2219.43 1073.25 2232.98 1073.25 2249.67C1073.25 2266.37 1086.9 2279.92 1103.75 2279.92Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Chair"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.86 2269.06C1220.7 2269.06 1234.36 2255.51 1234.36 2238.82C1234.36 2222.12 1220.7 2208.58 1203.86 2208.58C1187.01 2208.58 1173.36 2222.12 1173.36 2238.82C1173.36 2255.51 1187.01 2269.06 1203.86 2269.06Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Chair_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.63 2335.75C1300.48 2335.75 1314.13 2322.2 1314.13 2305.51C1314.13 2288.81 1300.48 2275.26 1283.63 2275.26C1266.79 2275.26 1253.13 2288.81 1253.13 2305.51C1253.13 2322.2 1266.79 2335.75 1283.63 2335.75Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Chair_3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289.89 2431.91C1306.74 2431.91 1320.39 2418.36 1320.39 2401.66C1320.39 2384.97 1306.74 2371.42 1289.89 2371.42C1273.04 2371.42 1259.39 2384.97 1259.39 2401.66C1259.39 2418.36 1273.04 2431.91 1289.89 2431.91Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Chair_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Cabinets_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1436.14 2424.62H1372.89V2553.85H1436.14V2424.62Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436.14 2286.15H1372.89V2415.38H1436.14V2286.15Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.312 2426.15H890.066V2555.38H953.312V2426.15Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.312 2286.15H890.066V2415.38H953.312V2286.15Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1072.09 2106.15L1072.09 2146.15L1255.66 2146.15L1255.66 2106.15L1163.87 2106.15L1072.09 2106.15Z",
    fill: "white",
    fillOpacity: 0.1,
    id: "Cabinet"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Walls, windows, doors and stairs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M955.185 1721L941.917 1696.06H969.337L955.185 1721ZM955.185 1721L955.702 1348M955.185 1721H891M955.185 1721H1026.96V1437.18M1026.33 1437.22H891M1017.95 1437.18V1721M1026.96 1425.42V1710.8M1025.32 1710.74H1158M1158 1710.8V1425.42M1158 1427.08H1025.32M955.503 1348.2H1091.86M1091.66 1348V1710.8M1091.8 1717.73C1095.61 1717.73 1098.7 1714.6 1098.7 1710.73C1098.7 1706.87 1095.61 1703.73 1091.8 1703.73C1087.98 1703.73 1084.89 1706.87 1084.89 1710.73C1084.89 1714.6 1087.98 1717.73 1091.8 1717.73Z",
    id: "Stairwell",
    stroke: "#999",
    strokeLinecap: "square",
    strokeWidth: 1.53846,
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Doors"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.064 2142.88V2225.03C123.789 2224.16 159.775 2187.71 159.775 2142.88",
    id: "Door phone box room",
    stroke: "#979797",
    strokeLinejoin: "round",
    strokeWidth: 3.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.726 2142.88V2225.03C377.451 2224.16 413.437 2187.71 413.437 2142.88M874.641 2162.6H792.299C793.176 2207.21 829.706 2243.12 874.641 2243.12",
    id: "Doors main room",
    stroke: "#979797",
    strokeLinejoin: "round",
    strokeWidth: 3.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452.79 2162.6H1535.13C1534.26 2207.21 1497.73 2243.12 1452.79 2243.12",
    id: "Door corner room",
    stroke: "#979797",
    strokeLinejoin: "round",
    strokeWidth: 3.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1512.31 388.317H1429.97C1430.84 343.696 1467.37 307.795 1512.31 307.795",
    id: "Door upper meeting room",
    stroke: "#979797",
    strokeLinejoin: "round",
    strokeWidth: 3.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.43 740.743H1416.08C1416.96 696.122 1453.49 660.22 1498.43 660.22",
    id: "Door wood room",
    stroke: "#979797",
    strokeLinejoin: "round",
    strokeWidth: 3.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1509.22 1042.38H1426.88C1427.76 997.761 1464.29 961.859 1509.22 961.859",
    id: "Door wood room_2",
    stroke: "#979797",
    strokeLinejoin: "round",
    strokeWidth: 3.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349.75 1613.34H1432.09C1431.22 1568.72 1394.69 1532.82 1349.75 1532.82",
    id: "Door restroom",
    stroke: "#979797",
    strokeLinejoin: "round",
    strokeWidth: 3.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1353.96 1710.69H1436.3C1435.43 1755.3 1398.9 1791.21 1353.96 1791.21",
    id: "Door restroom_2",
    stroke: "#979797",
    strokeLinejoin: "round",
    strokeWidth: 3.07692
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.584 1973.62V1858.6C970.563 1859.84 1021.24 1910.86 1021.24 1973.62",
    id: "Door stairwell",
    stroke: "#979797",
    strokeLinejoin: "round",
    strokeWidth: 3.07692
  })), /*#__PURE__*/React.createElement("g", {
    id: "Windows"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1602.68 2129.73H1619.16V2139.59H1602.68V2129.73ZM1561.5 2129.73H1577.98V2139.59H1561.5V2129.73Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.677 2129.73H757.692V2139.59H505.677V2129.73Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685.04 2560.28H1795.4V2576.71H1685.04V2560.28ZM1284.78 2560.28H1395.14V2576.71H1284.78V2560.28ZM1535.15 2560.28H1645.51V2576.71H1535.15V2560.28ZM1101.95 2560.28H1212.31V2576.71H1101.95V2560.28ZM919.114 2560.28H1029.47V2576.71H919.114V2560.28ZM736.279 2560.28H846.639V2576.71H736.279V2560.28ZM553.445 2560.28H663.805V2576.71H553.445V2560.28ZM298.136 2560.28H408.495V2576.71H298.136V2560.28ZM151.539 2560.28H261.898V2576.71H151.539V2560.28Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1950.23 261.286H1966.7V376.318H1950.23V261.286ZM1950.23 451.911H1966.7V566.942H1950.23V451.911ZM1950.23 672.114H1966.7V787.146H1950.23V672.114ZM1950.23 892.318H1966.7V1007.35H1950.23V892.318ZM1950.23 1112.52H1966.7V1227.55H1950.23V1112.52ZM1950.23 1398.46H1966.7V1513.49H1950.23V1398.46ZM1950.23 1641.67H1966.7V1756.7H1950.23V1641.67ZM1950.23 1822.43H1966.7V1937.46H1950.23V1822.43ZM1950.23 2003.2H1966.7V2118.23H1950.23V2003.2ZM1950.23 2183.96H1966.7V2298.99H1950.23V2183.96Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.96 1158.53H1342.43V1278.5H1325.96V1158.53Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.07 96.9553H1164.54V208.701H1148.07V96.9553ZM1148.07 254.713H1164.54V366.458H1148.07V254.713ZM1148.07 456.841H1164.54V529.146H1148.07V456.841ZM1148.07 642.535H1164.54V755.923H1148.07V642.535ZM1148.07 866.025H1164.54V1078.01H1148.07V866.025Z",
    fill: "black",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.01 1331.08H401.907V1347.52H168.01V1331.08ZM597.918 1331.08H831.815V1347.52H597.918V1331.08ZM915.82 1331.08H1139.83V1347.52H915.82V1331.08ZM1197.48 1331.08H1322.67V1347.52H1197.48V1331.08Z",
    fill: "black",
    fillOpacity: 0.06
  })), /*#__PURE__*/React.createElement("g", {
    id: "Walls",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outer walls"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1795.4 2556.99H1948.59V2580H1795.4V2556.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.51 2556.99H1685.04V2580H1645.51V2556.99ZM1212.31 2556.99H1284.78V2580H1212.31V2556.99ZM1029.47 2556.99H1101.95V2580H1029.47V2556.99ZM846.639 2556.99H919.114V2580H846.639V2556.99ZM663.804 2556.99H736.279V2580H663.804V2556.99ZM408.495 2556.99H553.445V2580H408.495V2556.99ZM261.898 2556.99H298.135V2580H261.898V2556.99ZM0 2556.99H151.538V2580H0V2556.99ZM1395.14 2556.99H1535.15V2580H1395.14V2556.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.77 0H1970V23.0064H1144.77V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1327.8H168.01V1350.8H0V1327.8ZM401.906 1327.8H597.918V1350.8H401.906V1327.8ZM831.814 1327.8H915.819V1350.8H831.814V1327.8ZM1139.83 1327.8H1197.48V1350.8H1139.83V1327.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1946.94 0H1970L1970 261.287H1946.94V0ZM1946.94 376.318H1970V451.911H1946.94V376.318ZM1946.94 566.943H1970V672.115H1946.94V566.943ZM1946.94 787.147H1970V892.318H1946.94V787.147ZM1946.94 1007.35H1970V1112.52H1946.94V1007.35ZM1946.94 1227.55H1970V1398.46H1946.94V1227.55ZM1946.94 1513.49H1970V1641.67H1946.94V1513.49ZM1946.94 1756.7H1970V1822.43H1946.94V1756.7ZM1946.94 1937.47H1970V2003.2H1946.94V1937.47ZM1946.94 2118.23H1970V2183.96H1946.94V2118.23ZM1946.94 2298.99H1970V2580H1946.94V2298.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.5 1135.53H1144.77V1158.53H1505.5V1135.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365.49 1278.5H1322.67V1382.03H1365.49V1278.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.77 366.459H1167.83V456.841H1144.77V366.459ZM1144.77 529.146H1167.83V642.535H1144.77V529.146ZM1144.77 755.923H1167.83V866.025H1144.77V755.923ZM1144.77 1078.01H1167.83V1138.82H1144.77V1078.01ZM1144.77 208.701H1167.83V254.713H1144.77V208.701ZM1144.77 1.64324H1167.83V96.9553H1144.77V1.64324Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1327.8H23.0602V2580L0 2580V1327.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner walls"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inner vertical wall"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1158 812H1509V835H1158V812Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.74 1960.65H1485.5V1996.81H1521.74V1960.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1516.35 1455.87H1493.21V1889.86H1516.35V1455.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.74 1341.99H1485.5V1378.14H1521.74V1341.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1493.21 446.25H1516.27V661.524H1493.21V446.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1508.04 385.448H1531.1V452.824H1508.04V385.448ZM1508.04 10.7728H1531.1V308.212H1508.04V10.7728Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.55 1041.89H1528.61V1158.56H1505.55V1041.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.78 889.527H1508.64V968.015H1531.78V889.527Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497.84 915.69H1520.98L1520.98 740.247H1497.84L1497.84 915.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1436.32 2241.48H1452.79V2570.14H1436.32V2241.48ZM1436.32 2126.45H1452.79V2164.24H1436.32V2126.45Z",
    id: "Inner vertical wall_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inner vertical wall_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1335.38 1377.38H1354.38L1354.38 1533.59H1335.38L1335.38 1377.38ZM1335.38 1612.85H1354.38V1712.21H1335.38V1612.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1354.38 1789.35H1335.38V1994.51H1354.38V1789.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1182.66 1327.8H1159.6V1994.98H1182.66V1327.8Z",
    id: "Inner vertical wall_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inner vertical wall_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M889.465 1327.8H866.405V1994.98H889.465V1327.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.465 2241.48H872.993V2570.14H889.465V2241.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.465 2126.45H872.993V2164.24H889.465V2126.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M265.192 2126.45H281.664V2570.14H265.192V2126.45Z",
    id: "Inner vertical wall_6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Horizontal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Inner horizontal wall"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1289.59 2220.74V2151.49L1278.79 2151.49V2220.74H1289.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.49 2226.9L1050.49 2157.64H1039.7L1039.7 2226.9H1050.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.79 2151.49L1039.7 2151.49V2162.26H1278.79V2151.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner horizontal wall_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1619.16 2126.45H1950.23V2142.88H1619.16V2126.45ZM1577.98 2126.45H1602.68V2142.88H1577.98V2126.45ZM1441.26 2126.45H1561.5V2142.88H1441.26V2126.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.692 2126.45H884.524V2142.88H757.692V2126.45ZM411.789 2126.45H505.677V2142.88H411.789V2126.45ZM158.127 2126.45H334.373V2142.88H158.127V2126.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88329 2126.45H80.7111V2142.88H9.88329V2126.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Inner horizontal wall_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1017.94 1971.97H1347.37V1994.98H1017.94V1971.97ZM872.993 1971.97H909.231V1994.98H872.993V1971.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.584 1960.65H447.347V1996.81H483.584V1960.65Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1178.53 1612.85H1354.38V1629.77H1178.53V1612.85Z",
    id: "Inner horizontal wall_4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.447 1344.23H484.264V1383.67H581.447V1344.23Z",
    id: "Inner horizontal wall_5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1891.2 1382H1642.84V1398.93H1891.2V1382Z",
    id: "Inner horizontal wall_6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1854.18 978.788H1642.84V995.717H1854.18V978.788Z",
    id: "Inner horizontal wall_7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.77 430.548H1520.33V453.554H1144.77V430.548Z",
    id: "Inner horizontal wall_8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Desks",
    fill: "white",
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1760.31 46.4973V196.632H1685.54V46.4973H1760.31ZM1677.95 100.709V142.42H1636.13V100.709H1677.95Z",
    id: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.25 196.632V46.4973H1841.02V196.632H1766.25ZM1848.61 142.42V100.709H1890.44V142.42H1848.61Z",
    id: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.31 312.625V387.192H1642.72V312.625H1760.31ZM1722.43 263.342V305.054H1680.6V263.342H1722.43Z",
    id: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.79 312.625V387.192H1766.25V312.625H1916.79ZM1862.43 263.342V305.054H1820.61V263.342H1862.43Z",
    id: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.72 394.763H1760.31V469.331H1642.72V394.763ZM1680.6 476.902H1722.43V518.614H1680.6V476.902Z",
    id: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.25 468.668L1766.25 394.101L1916.79 394.101L1916.79 468.668L1766.25 468.668ZM1820.61 517.951L1820.61 476.239L1862.43 476.239L1862.43 517.951L1820.61 517.951Z",
    id: 31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.31 667.462V742.03H1642.72V667.462H1760.31ZM1722.43 618.179V659.891H1680.6V618.179H1722.43Z",
    id: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.72 749.601H1760.31V824.168H1642.72V749.601ZM1680.6 831.739H1722.43V873.451H1680.6V831.739Z",
    id: 34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.25 749.601H1916.79V824.168H1766.25V749.601ZM1820.61 831.739H1862.43V873.451H1820.61V831.739Z",
    id: 35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793.25 1103.38V1177.95H1642.72V1103.38H1793.25ZM1738.9 1054.1V1095.81H1697.07V1054.1H1738.9Z",
    id: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.48 1177.95L1798.88 1177.95L1798.88 1103.38L1916.48 1103.38L1916.48 1177.95ZM1878.59 1095.81L1836.77 1095.81L1836.77 1054.1L1878.59 1054.1L1878.59 1095.81Z",
    id: 37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1642.72 1184.87H1793.25V1259.44H1642.72V1184.87ZM1697.07 1267.01H1738.9V1308.72H1697.07V1267.01Z",
    id: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1798.88 1184.87H1916.48V1259.44H1798.88V1184.87ZM1836.77 1267.01H1878.59V1308.72H1836.77V1267.01Z",
    id: 39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1671.36 1508.56V1658.69H1596.59V1508.56H1671.36ZM1589.01 1562.77V1604.48H1547.18V1562.77H1589.01Z",
    id: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1794.9 1505.27V1579.84H1677.31V1505.27H1794.9ZM1757.02 1455.99V1497.7H1715.19V1455.99H1757.02Z",
    id: 41
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.79 1505.27V1579.84H1799.2V1505.27H1916.79ZM1878.91 1455.99V1497.7H1837.08V1455.99H1878.91Z",
    id: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.31 1587.41H1794.9V1661.98H1677.31V1587.41ZM1715.19 1669.55H1757.02V1711.26H1715.19V1669.55Z",
    id: 43
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1799.2 1661.98V1587.41H1916.79V1661.98H1799.2ZM1837.08 1711.26V1669.55H1878.91V1711.26H1837.08Z",
    id: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.66 1843.68V1918.25H1608.12V1843.68H1758.66ZM1704.31 1794.4V1836.11H1662.48V1794.4H1704.31Z",
    id: 45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.79 1843.68V1918.25H1766.25V1843.68H1916.79ZM1862.43 1794.4V1836.11H1820.61V1794.4H1862.43Z",
    id: 46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.12 1925.82H1758.66V2000.39H1608.12V1925.82ZM1662.48 2007.96H1704.31V2049.67H1662.48V2007.96Z",
    id: 47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.25 1925.82H1916.79V2000.39H1766.25V1925.82ZM1820.61 2007.96H1862.43V2049.67H1820.61V2007.96Z",
    id: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.79 667.462V742.03H1766.25V667.462H1916.79ZM1862.43 618.179V659.891H1820.61V618.179H1862.43Z",
    id: 50
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrundrissOben);
export default __webpack_public_path__ + "static/media/grundriss-oben.d3756c70be9e241dd38dd9eaf2c2d30e.svg";
export { ForwardRef as ReactComponent };